import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { useState } from "react";

interface RatingProps {
  value?: number;
  max?: number;
  readOnly?: boolean;
  onChange?: (newValue: number) => void;
}

const Rating = ({
  value = 0,
  max = 5,
  readOnly = false,
  onChange = () => ({}),
}: RatingProps) => {
  const [hoveredStar, setHoveredStar] = useState(0);

  const isActive = (n: number) => n <= value;
  const isHovered = (n: number) => n <= hoveredStar;

  const handleStarHover = (star: number) => {
    setHoveredStar(star);
  };

  const handleStarClick = (star: number) => {
    onChange(star);
  };

  return readOnly ? (
    <div className="flex items-center gap-1">
      <IconStarFilled className="text-icon-warning" />
      <span className="text-text-base typography-medium-base">{`${value}/${max}`}</span>
    </div>
  ) : (
    <div className="flex text-icon-warning gap-0.5">
      {new Array(max).fill(0).map((_, i) => (
        <button
          key={`star-${i}`}
          disabled={readOnly}
          type="button"
          onClick={() => handleStarClick(i + 1)}
          onMouseEnter={() => handleStarHover(i + 1)}
          onMouseLeave={() => handleStarHover(0)}
        >
          {(hoveredStar > 0 && isHovered(i + 1)) || (hoveredStar === 0 && isActive(i + 1)) ? <IconStarFilled /> : <IconStar />}
        </button>
      ))}
    </div>
  );
};

export default Rating;
